import './section-content.scss';

import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { ItemCardSkeleton } from '@sola/ark-core/molecules/item-card/item-card.tsx';
import { TooltipInfo } from '@sola/ark-core/molecules/tooltip-info/tooltip-info.tsx';

type SectionContentHeadingProps =
  | {
      isLoadingHeading: true;
      heading?: never;
      subheading?: never;
      tooltipContent?: never;
    }
  | {
      isLoadingHeading?: false;
      heading: string;
      subheading?: string | React.ReactNode;
      tooltipContent?: string;
    };

type SectionContentContentProps =
  | {
      isLoadingContent: true;
      children?: React.ReactNode;
    }
  | {
      isLoadingContent?: false;
      children: React.ReactNode;
    };

export type SectionContentProps = SectionContentHeadingProps &
  SectionContentContentProps;

/**
 * Section for Card Lists.
 * In the future, we may want to make this more composable depending on our needs.
 */
export const SectionContent: React.FC<SectionContentProps> = ({
  children,
  heading,
  tooltipContent,
  subheading,
  isLoadingHeading,
  isLoadingContent,
}) => {
  return (
    <section className="SectionContent max-w-md flex flex-col items-start @mdc:flex-row @mdc:justify-between @mdc:gap-comfy-sm @lgc:gap-comfy-xl">
      <div className="SectionContent__labels mb-comfy-xl @mdc:mb-none shrink-0">
        {!isLoadingHeading && (
          <>
            <div className="flex items-center label-potent label-md gap-snug-lg label-neutral-mild">
              <h2 className="label-potent label-md label-neutral-mild">
                {heading}
              </h2>

              {tooltipContent && (
                <TooltipInfo
                  triggerClassName="SectionContent__tticon"
                  contentClassName="label-md lg:label-lg"
                  alignOffset={-12}
                  onPointerDownOutside={(e) => {
                    e.preventDefault();
                  }}
                >
                  {tooltipContent}
                </TooltipInfo>
              )}
            </div>
            {subheading && (
              <span className="label-moderate label-lg label-neutral-amplified">
                {subheading}
              </span>
            )}
          </>
        )}

        {isLoadingHeading && <Skeleton height={50} />}
      </div>
      <div className="SectionContent__content w-full flex flex-col gap-comfy-xs">
        {isLoadingContent ? <ItemCardSkeleton /> : children}
      </div>
    </section>
  );
};
